// extracted by mini-css-extract-plugin
export default {"symbolsBarContainer":"symbol-bar_symbolsBarContainer__VSCG6","symbolButton":"symbol-bar_symbolButton__2ObgK"};